/* TeerreStock — comportamientos compartidos del tema. */

(function () {
  'use strict';

  /**
   * Aparición al entrar en pantalla.
   * Se marcan los elementos con la clase .trs-reveal; al cruzar el umbral
   * se les añade .is-visible y se deja de observarlos.
   */
  function initReveal() {
    var items = document.querySelectorAll('.trs-reveal:not(.is-visible)');
    if (!items.length) return;

    // Sin IntersectionObserver (o con movimiento reducido) lo mostramos todo.
    var reduced =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!('IntersectionObserver' in window) || reduced) {
      items.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
    );

    items.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }

  // El personalizador de Shopify vuelve a inyectar secciones al editarlas.
  document.addEventListener('shopify:section:load', initReveal);
})();
